import React, { Component } from 'react';
import { connect } from 'react-redux';

import imageBankAccount from '../images/payment-methods/bank_account@2x.png';
import imageBitcoin from '../images/payment-methods/bitcoin@2x.png';
import imageClickToPay from '../images/payment-methods/clicktopay@2x.png';
import imageGooglePay from '../images/payment-methods/googlepay@2x.png';
import imageGopay from '../images/payment-methods/gopay@2x.png';
import imageMPayment from '../images/payment-methods/mpayment@2x.png';
import imagePaymentCard from '../images/payment-methods/payment_card@2x.png';
import imagePaySafeCard from '../images/payment-methods/paysafecard@2x.png';
import imagePrsms from '../images/payment-methods/prsms@2x.png';
import imageSupercash from '../images/payment-methods/supercash@2x.png';


class PaymentMethodInput extends Component {

	state = {
		imageWidth: 0,
		imageHeight: 0,
	};

	images = {
		BANK_ACCOUNT: imageBankAccount,
		BITCOIN: imageBitcoin,
		CLICK_TO_PAY: imageClickToPay,
		GOPAY: imageGopay,
		GPAY: imageGooglePay,
		MPAYMENT: imageMPayment,
		PAYMENT_CARD: imagePaymentCard,
		PAYSAFECARD: imagePaySafeCard,
		PRSMS: imagePrsms,
		SUPERCASH: imageSupercash
	};

	onChange = (e) => {
		this.props.input.onChange(e.target.value);
	};

	handleImageSize = (el) => {
		const self = this;

		if (!el) return;

		el.onload = function() {
			self.setState({
				imageWidth: this.naturalWidth,
				imageHeight: this.naturalHeight,
			});
		}
	};

	render() {
		const { instrument, lang } = this.props;

		const attributes = {
			id: `${this.props.input.name}-${instrument.paymentInstrument}`,
			name: this.props.input.name,
			type: 'radio',
			value: instrument.paymentInstrument,
			onChange: this.onChange,
			checked: this.props.checked || false,
		};

		let label = instrument.label[lang] || instrument.label['cs'];

		if (label === 'Bankovní převod') {
			label = 'On-line bankovní převod';
		}

		return (
			<div className="payment-method-input">
				<input {...attributes} />
				<label htmlFor={attributes.id}>
					{!!this.images[instrument.paymentInstrument] &&
						<span className="payment-method-input__img-container">
							<img
								src={this.images[instrument.paymentInstrument]}
								alt={label}
								className="payment-method-input__img"
								ref={el => this.handleImageSize(el) }
								width={this.state.imageWidth / 2}
								height={this.state.imageHeight / 2}
							/>
						</span>
					}
					<span className="payment-method-input__label">{label}</span>
				</label>
			</div>
		);
	}
}

export default connect(state => ({
	lang: state.app.lang,
}))(PaymentMethodInput);



// WEBPACK FOOTER //
// ./src/components/PaymentMethodInput.jsx